// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"272":"8b96927d","552":"188ced94","695":"481b52ff","761":"a577f2f1","878":"01bb85db"}[chunkId] + ".chunk.js";
};